import { useEffect } from 'react';
import { formatDisplayPrice } from '../../face-identity/utils/servicePriceOptions';

export default function ServiceSessionCartModal({ open, summary, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || !summary?.lines?.length) return null;

  const { lines, subtotalMrp, totalPayable, totalSaved } = summary;
  const hasSavings = totalSaved != null && totalSaved > 0;
  const subtotal = subtotalMrp != null ? subtotalMrp : totalPayable;

  return (
    <div
      className="salon-service-start__cart-modal-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="salon-service-start__cart-modal"
        role="dialog"
        aria-labelledby="salon-service-cart-title"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="salon-service-start__cart-modal-head">
          <h2 id="salon-service-cart-title" className="salon-service-start__cart-modal-title">
            Selected services
          </h2>
          <button
            type="button"
            className="salon-service-start__cart-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </header>
        <ul className="salon-service-start__cart-modal-lines">
          {lines.map((line) => (
            <li key={line.id} className="salon-service-start__cart-modal-line">
              <div className="salon-service-start__cart-modal-line-main">
                <span className="salon-service-start__cart-modal-line-name">{line.name}</span>
                {line.qty > 1 ? (
                  <span className="salon-service-start__cart-modal-line-qty">×{line.qty}</span>
                ) : null}
              </div>
              <div className="salon-service-start__cart-modal-line-prices">
                {line.saved > 0 ? (
                  <span className="salon-service-start__cart-modal-mrp">
                    {formatDisplayPrice(line.mrp)}
                  </span>
                ) : null}
                <strong>{formatDisplayPrice(line.payable)}</strong>
                <span
                  className={
                    line.discountPct != null
                      ? 'salon-service-start__cart-modal-discount'
                      : 'salon-service-start__cart-modal-discount salon-service-start__cart-modal-discount--empty'
                  }
                >
                  {line.discountPct != null ? `${line.discountPct}% off` : '—'}
                </span>
              </div>
            </li>
          ))}
        </ul>
        <footer className="salon-service-start__cart-modal-totals">
          <div className="salon-service-start__cart-modal-row">
            <span>Subtotal</span>
            <span>{subtotal != null ? formatDisplayPrice(subtotal) : '—'}</span>
          </div>
          <div
            className={`salon-service-start__cart-modal-row salon-service-start__cart-modal-row--saved${
              hasSavings ? '' : ' salon-service-start__cart-modal-row--placeholder'
            }`}
          >
            <span>Discount</span>
            <span>{hasSavings ? `−${formatDisplayPrice(totalSaved)}` : '—'}</span>
          </div>
          <div
            className={`salon-service-start__cart-modal-row salon-service-start__cart-modal-row--saved${
              hasSavings ? '' : ' salon-service-start__cart-modal-row--placeholder'
            }`}
          >
            <span>Total saved</span>
            <span>{hasSavings ? formatDisplayPrice(totalSaved) : '—'}</span>
          </div>
          <div className="salon-service-start__cart-modal-row salon-service-start__cart-modal-row--total">
            <span>Total</span>
            <strong>{totalPayable != null ? formatDisplayPrice(totalPayable) : '—'}</strong>
          </div>
        </footer>
      </div>
    </div>
  );
}
